import { Share, Mail, MessageSquare, Phone, MessageCircle, User } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Vehicle } from '../types';
interface VehicleActionsProps {
  vehicle: Vehicle;
}
export const VehicleActions = ({
  vehicle
}: VehicleActionsProps) => {
  const formatPrice = (price: number) => {
    if (!price || price === 0) {
      return "Prix sur demande";
    }
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0
    }).format(price);
  };
  const shareUrl = `${window.location.origin}?vehicle=${vehicle.id}`;
  const shareText = `Découvrez ce ${vehicle.title} - ${formatPrice(vehicle.price)} chez Trucks 52 SARL`;
  const contactMessage = `Bonjour Laurent, je suis intéressé(e) par votre annonce "${vehicle.title}" au prix de ${formatPrice(vehicle.price)}. Pourriez-vous me donner plus d'informations ? Cordialement.`;
  const handleEmailShare = () => {
    const subject = encodeURIComponent(`Partage d'annonce Trucks 52 - ${vehicle.title}`);
    const body = encodeURIComponent(`${shareText}\n\nVoir l'annonce : ${shareUrl}\n\nTrucks 52 SARL - Spécialiste poids lourds d'occasion`);
    window.open(`mailto:?subject=${subject}&body=${body}`);
  };
  const handleEmailContact = () => {
    const subject = encodeURIComponent(`Demande d'informations - ${vehicle.title}`);
    const body = encodeURIComponent(`${contactMessage}\n\nCordialement`);
    window.open(`mailto:trucks.52@orange.fr?subject=${subject}&body=${body}`);
  };
  const handleSMSContact = () => {
    const message = encodeURIComponent(`${contactMessage.substring(0, 140)}...`);
    window.open(`sms:+33608248529?body=${message}`);
  };
  const handleWhatsAppShare = () => {
    const message = encodeURIComponent(`${shareText} ${shareUrl}`);
    window.open(`https://wa.me/?text=${message}`);
  };
  const handleWhatsAppContact = () => {
    const message = encodeURIComponent(contactMessage);
    window.open(`https://wa.me/33608248529?text=${message}`);
  };
  const handlePhoneCall = () => {
    window.open('tel:+33608248529');
  };
  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: shareText,
          url: shareUrl
        });
      } catch (error) {
        console.log('Partage annulé');
      }
    } else {
      navigator.clipboard.writeText(shareUrl);
      alert('Lien copié dans le presse-papiers !');
    }
  };
  return <div className="flex flex-col space-y-4 mt-4 w-full">
      {/* Boutons de partage avec icônes uniquement */}
      <div className="flex flex-col space-y-2">
        <h4 className="text-sm font-medium text-gray-700">Partager cette annonce</h4>
        <div className="flex flex-wrap gap-2 w-full">
          <Button size="sm" variant="outline" onClick={handleNativeShare} className="flex-1 min-w-0 text-xs px-2" title="Partager">
            <Share className="h-4 w-4" />
          </Button>
          <Button size="sm" variant="outline" onClick={handleEmailShare} className="flex-1 min-w-0 text-xs px-2" title="Partager par email">
            <Mail className="h-4 w-4" />
          </Button>
          <Button size="sm" variant="outline" onClick={handleWhatsAppShare} className="flex-1 min-w-0 bg-green-50 hover:bg-green-100 text-green-700 text-xs px-2" title="Partager sur WhatsApp">
            <MessageSquare className="h-4 w-4" />
          </Button>
        </div>
      </div>

      {/* Boutons de contact avec icônes */}
      <div className="flex flex-col space-y-2">
        <div className="flex items-center gap-2">
          <User className="h-4 w-4 text-gray-600" />
          <h4 className="text-sm font-medium text-gray-700">Contacter Laurent DESNOUVEAUX</h4>
        </div>
        <div className="flex flex-col gap-2 w-full">
          <div className="flex gap-2 w-full">
            <Button size="sm" variant="default" onClick={handlePhoneCall} className="flex-1 bg-blue-600 hover:bg-blue-700 text-xs px-2 min-w-0" title="Appeler">
              <Phone className="h-4 w-4 mr-1 flex-shrink-0" />
              <span className="truncate text-xs font-semibold">06 08 24 85 29</span>
            </Button>
            <Button size="sm" variant="default" onClick={handleEmailContact} className="flex-1 bg-gray-600 hover:bg-gray-700 text-xs px-2 min-w-0" title="Envoyer un email">
              <Mail className="h-4 w-4" />
            </Button>
          </div>
          <div className="flex gap-2 w-full">
            <Button size="sm" variant="default" onClick={handleSMSContact} className="flex-1 bg-purple-600 hover:bg-purple-700 text-xs px-2 min-w-0" title="Envoyer un SMS">
              <Phone className="h-4 w-4" />
            </Button>
            <Button size="sm" variant="default" onClick={handleWhatsAppContact} className="flex-1 bg-green-600 hover:bg-green-700 text-xs px-2 min-w-0" title="Contacter sur WhatsApp">
              <MessageCircle className="h-4 w-4" />
            </Button>
          </div>
        </div>
        <div className="bottom-0 mt-2 px-1 py-0 my-[5px] rounded-none text-center text-sm">
          2 PL. DE L'EGLISE - RECOURT 52140 VAL-DE-MEUSE<br />
          Trucks 52 - Spécialiste poids lourds d'occasion
        </div>
      </div>
    </div>;
};